const parameters = {
    dataRetriever: {
        host: "https://data-retriever.rur.kifu.hu"
    },
    mapConfiguration: {
        tileServer: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png\n",
        attribution: "&copy;<a target='_blank' href='https://osm.org/copyright'>OpenStreetMap</a> contributors",
        partnershipRoutesTileServerUrl: "https://tileserver.rur.kifu.hu/data",
        pathStyles: {
            partnershipRoutesHighlighted: {
                stroke: true,
                color: "#c78400",
                weight: 3,
                opacity: 0.8,
            },
            partnershipRoutesBackground: {
                stroke: true,
                color: "#7E7B68",
                weight: 2,
                opacity: 0.7,
                dashArray: '4'
            },
            detours: {
                stroke: true,
                color: "#7e5400",
                weight: 3,
                opacity: 0.9,
                dashArray: '4'
            }
        },
        nutsStyle: {
            0: {
                weight: 1,
                opacity: 1,
                color: "#2984fc",
                fillOpacity: 0.5
            },
            1: {
                weight: 2,
                opacity: 1,
                color: "#4f84c0",
                fillOpacity: 0.4
            },
            2: {
                weight: 2,
                opacity: 1,
                color: "#8a8462",
                fillOpacity: 0.3
            },
            3: {
                weight: 3,
                opacity: 1,
                color: "#a68435",
                fillOpacity: 0.2
            },
            highlighted: {
                weight: 3,
                opacity: 1,
                color: "#c78400",
                fillOpacity: 0.50
            }
        }
    },
    projectWebAddress: "https://rurallure.eu"
};
export default parameters;
